import { Stack, Typography } from '@mui/material'
import React from 'react'

export default function TitleInfoStack({
    title,
    value,
    elementValue = undefined,
    ...props
}) {
    return (
        <Stack spacing={1} {...props}>
            <Typography variant="body2" fontWeight="bold" color="text.lighter">
                {title}
            </Typography>
            {
                !!elementValue ?
                    elementValue
                    :
                    <Typography fontWeight="bold">
                        {value}
                    </Typography>
            }
        </Stack>
    )
}
